import { useEffect, useState } from 'react';
import { DineRewardsManager } from '../managers/DineRewards.manager';

export const useGDPRExtensions = () => {
	const [gdprExtensions, setGDPRExtensions] = useState<string[]>([]);

	useEffect(() => {
		const retrieveGDPRExtensions = async () => {
			const response = await DineRewardsManager.GetGDPRExtensions();
			if (response) {
				setGDPRExtensions(response);
			}
		};
		retrieveGDPRExtensions();
	}, []);

	return gdprExtensions;
};
